import PaymentDetails from '../components/PaymentDetails';
import ShipTo from '../components/ShipTo';
import FrequencyDetails from '../list/components/subscription/FrequencyDetails';

const ClubMembershipInfo = (props) => {
  const { clubMembership } = props;
  return (
    <>
      <div className="c7-account-row c7-account-row--basic">
        <h3>Personal details</h3>
      </div>

      <div className="c7-account-row">
        <div className="c7-account-tile">
          <ShipTo clubMembership={clubMembership} />
        </div>

        <div className="c7-account-tile">
          <div className="c7-account-tile__section">
            <PaymentDetails clubMembership={clubMembership} />
          </div>
          {clubMembership.club.type === 'Subscription' && (
            <div className="c7-account-tile__section">
              <FrequencyDetails clubMembership={clubMembership} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ClubMembershipInfo;
